function setValue(resource, property) {
	return function(event) {
		const target = event.currentTarget || event.target
		resource[property] = target.value
	}
}

export default setValue
